import React from 'react'
import noop from 'lodash/noop'
import { Box, Flex } from 'rebass'
import styled from 'styled-components'

import '@trv-tds/core/dist/css/tds.min.css'
import { expirationTime, Expiry, warnTime } from './Expiry'
import { Footer } from './footer/TDSFooter'
import { Header } from './header/Header'
import { Notifications } from './notifications/Notifications'
import { TheRouter } from './Router'
import { initialGlobalState } from './store'

const StyledFlex = styled(Flex)`
  min-height: 100vh;
`

const App: React.FC = () => (
  <StyledFlex flexDirection="column">
    <Header/>
    <Box width={[1, 15/16, '800px']} flex="1 0 auto" mx="auto">
      <Notifications />
      <Expiry
        {...initialGlobalState}
        claimError={noop}
        duration={parseInt(process.env.REACT_APP_TIMEOUT_DURATION ?? String(expirationTime), 10)}
        warnAt={parseInt(process.env.REACT_APP_TIMEOUT_WARNAT ?? String(warnTime), 10)}
      />
      <TheRouter />
    </Box>
    <Footer />
  </StyledFlex>
)

export { App }
